import React, { useState, useEffect, ChangeEvent, FormEvent, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { startUpload, uploadSuccess, uploadFailure } from '../../store/imageSlice';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchUserData } from '../../store/UserSlice';
import { BASE_URL } from '../../config';

interface PopupContentEditProps {
    closePopups: () => void;
    existingHealthConditionId: string;
}

const PopupContentEdit: React.FC<PopupContentEditProps> = ({ closePopups, existingHealthConditionId }) => {
    const dispatch = useDispatch<any>();
    const [title, setTitle] = useState(''); // Set the initial value for the title
    const [image, setImage] = useState<File | null>(null);
    const [images, setImages] = useState<string | null>(null);
    const [selectedImage, setSelectedImage] = useState<File | null>(null); // Set the initial value for the selected image
    const [error, setError] = useState<string | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [someState, setSomeState] = useState('');
  
console.log(image);


const [healthConditionDetails, setHealthConditionDetails] = useState<any | null>(null);
console.log(healthConditionDetails);
useEffect(() => {
    // Function to fetch health condition details based on ID
    const fetchHealthConditionDetails = async () => {
      try {
        const storedData = localStorage.getItem('loginData');
        if (!storedData) {
          // Handle the case where the stored data is null or undefined
          console.error('Stored data is null or undefined.');
          // You might want to handle this case appropriately, e.g., redirect to login
          return;
        }
  
        const parsedData = JSON.parse(storedData);
        const accessToken = parsedData?.accessToken;
        
        if (!accessToken) {
          // Handle the case where the access token is not available
          console.error('Access token is not available.');
          // You might want to handle this case appropriately, e.g., redirect to login
          return;
        }
  
        const response = await axios.get(`${BASE_URL}/api/v1/healthConditions/${existingHealthConditionId}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            // Add other headers if needed
          },
        });
  
        setHealthConditionDetails(response.data.data);
        // Set the title with the fetched data
        setTitle(response.data.data.name || ''); // Assuming the name field holds the title
        setImages(response.data.data.icon || ''); // Assuming the name field holds the title

        // You can similarly set other form fields based on the fetched data
      } catch (error) {
        console.error('Error fetching health condition details:', error);
      }
    };
  
    if (existingHealthConditionId) {
      fetchHealthConditionDetails();
    }
  }, [existingHealthConditionId]);

  const handleTitleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedImage(file);
    }
    // Validate file type
    if (file && file.type.includes('image')) {
      // Set the selected image for preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(file);
      };
      reader.readAsDataURL(file);

      // Set the selected image file
      setImage(file);
      setError(null);
    } else {
      // Handle invalid file type
      setSelectedImage(null);
      setImage(null);
      setError('Please upload a valid image file.');
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    
    // Dispatch startUpload action
    dispatch(startUpload());

    try {
      const formData = new FormData();
      
      if (selectedImage) {
        
        formData.append('icon', selectedImage);
        formData.append('name', title);
        
      } else {
        formData.append('name', title);
        // Handle the case where selectedImage is null
        // For example, show an error message or take appropriate action
        
      }

      const storedData = localStorage.getItem('loginData');
      if (!storedData) {
        // Handle the case where the stored data is null or undefined
        console.error('Stored data is null or undefined.');
        dispatch(uploadFailure('Stored data is null or undefined.'));
        return;
      }
      
      const parsedData = JSON.parse(storedData);
      const accessToken = parsedData?.accessToken;

      if (accessToken) {     
        if (existingHealthConditionId) {
            let apiUrl = `${BASE_URL}/api/v1/healthConditions`;
          // If an existing health condition ID is provided, update the existing health condition
          apiUrl += `/${existingHealthConditionId}`;
        

        // Use POST for adding and PUT for updating
        const method = existingHealthConditionId ? 'PUT' : 'POST';

        const response = await axios({
          method,
          url: apiUrl,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${accessToken}`,
            // Add other headers if needed
          },
        });
        
        // Dispatch uploadSuccess action
        dispatch(uploadSuccess(response.data.imageUrl));
        

        setSomeState('someValue');
        
        }
      } else {
        // Handle the case where the access token is not available
        console.error('Access token is not available.');
        dispatch(uploadFailure('Access token is not available.'));
      }
    } catch (error: any) {        
      // Dispatch uploadFailure action
      toast.error(error.response.data.error.message);
      // dispatch(uploadFailure(error.message));
    }
  };
  useEffect(() => {
    // Check if someState has changed and then dispatch fetchUserData
    if (someState === 'someValue') {
      dispatch(fetchUserData()).then(()=> {
        closePopups();
        toast.success("Sucessfully Updated.");
      });
    }
  }, [dispatch, someState]);

  return (
    <div className="popup-overlay">
    <div className="relative bg-white px-2 md:px-8 w-80 md:w-[32rem] rounded-lg text-left">
      <button onClick={closePopups} className="close-btn">
        &times;
      </button>     
    <div className="max-w-md mt-2 m-auto p-4 pb-4 md:p-8 bg-white rounded ">
      <h2 className="text-xl md:text-2xl flex font-gilroy mb-6 font-bold  text-[#263238]">
        <img src='./images/round_icon.png' alt="condition" className='object-contain pr-2'/>
        Update Condition
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-[#607D8B] text-sm mb-2 font-gilroy" htmlFor="image">
            Add Icon
          </label>
          <div className="flex items-center  w-full">
          <label className={`flex flex-col items-center  w-32 h-30 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50  hover:bg-gray-100 ${selectedImage instanceof File ? "hidden" : ""}`}>
              <div className="flex flex-col items-center justify-center pt-5 pb-6 " >
                <img src='./images/gallery-add.png' alt="upload"  />
                <p className="text-xs text-[#4C535F] mt-4 font-gilroy">Upload Icon</p>
              </div>
              <input
                    id="image"
                    type="file"
                    name="image"
                    onChange={handleImageChange}
                    className={"visually-hidden"} // Corrected syntax
                    accept="image/*"
                    required={!images}                     
                    ref={fileInputRef}
                  />  

            </label>
            {selectedImage instanceof File && (
              <img src={URL.createObjectURL(selectedImage)} alt="preview" className="w-auto max-w-md pl-2 h-32 object-contain" />
            )}
            {images && (
            <img src={images} alt="preview" className={`w-auto max-w-md pl-2 h-32 object-contain ${selectedImage &&("hidden")} `} />
            )}

            {error && <p style={{ color: 'red' }}>{error}</p>}
          </div>
        </div>

        <div className="mb-6 mt-4">
          <label className="block text-[#607D8B] text-sm mb-2  font-gilroy" htmlFor="title">
            Health Conditions
          </label>
          <input
            type="text"
            id="title"
            name="title"
            value={title}
            onChange={handleTitleChange}
            className="w-full  font-gilroy px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 bg-[#F5F7F8]"
            placeholder="Enter title"
            required
          />
        </div>  
        <button
          type="submit"
          className="bg-[#B4804A] font-gilroy w-full text-white py-2 px-4 font-semibold rounded-md"
        >
          Update Condition
        </button>
      </form>
    </div>
    </div>
      </div>
  );
};

export default PopupContentEdit;
